import PassportizationIcon from './component'

export default PassportizationIcon
